import React, { useEffect, useState } from "react";
import "./Logout_Modal.css";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import Gray_Btn from "../../common_btn/gray_btn/Gray_Btn";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { logout, setIsSignedOut } from "../../../../features/auth/authSlice";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import Success_Modal from "../success_modal/Success_Modal";
import Success_Modal_LogOut from "../success_modal/Success_Modal_logOut";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { appSetup } from "../../../../features/master/masterSlice";
const Logout_Modal = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSignin = useSelector((state) => state.auth.is_signin);

  const [showSuccess, setShowSuccess] = useState(false);

  // const handleCloseLogout = async () => {
  //   Cookies.remove("harvestera_security");
  //   dispatch(setIsSignedOut());
  //   setShowLogin(true);
  //   props?.onHide();

  //   dispatch(getAllCart(isSignin));
  //   dispatch(getAllWishlist());

  //   setTimeout(() => {
  //      navigate("/");
  //     setShowLogin(false);

  //   }, 3000);
  //   // const res = await dispatch(logout());

  //   // if (res.meta?.requestStatus === "fulfilled") {

  //   //   //   setShow(false);
  //   //   //
  //   // } else if (res.meta?.requestStatus === "rejected") {
  //   //   console.log("Error:", res.payload || "User info fetch failed");
  //   // }
  // };
  const handleCloseLogout = async () => {
    // 1️⃣ Immediately show success modal
    setShowSuccess(true);

    // 2️⃣ Remove token and reset data
    Cookies.remove("harvestera_security");
    dispatch(setIsSignedOut());
    dispatch(getAllCart(false));
    dispatch(getAllWishlist());

    // 4️⃣ Close success modal and navigate after delay
    setTimeout(() => {
      setShowSuccess(false);
      navigate("/");
    }, 2000);
  };


  const app_setup = useSelector((state) => state.master.app_setup);
    
      useEffect(() => {
        dispatch(appSetup());
      }, [dispatch]);

  return (
    <>
      <Modal className="Logout_Modal" {...props} centered>
        <div className="logo_holder">
          <img
            // src="/assets/images/logo/new_ekansi_logo.png"
            src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
            className="logo_img"
          />
        </div>
        <Modal.Body>
          <p className="modal_title">Are you sure </p>
          <p className="modal_title">you want to log out?</p>

          <div className="btn_holder">
            <Gray_Btn
              btnText={"No"}
              onClick={() => {
                props?.onHide();
              }}
            />
            <Green_btn
              btnText="Yes"
              onClick={() => {
                handleCloseLogout();
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Success_Modal_LogOut
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
        }}
        successText="LogOut Successful!"
      />
    </>
  );
};

export default Logout_Modal;
